import {
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class ManageUsersPermisionsInterceptor implements HttpInterceptor {
  constructor(protected httpClient: HttpClient) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.requestHandler(request)).pipe(
      switchMap((event: HttpEvent<any>) => {
        if (
          request.url.indexOf('/api/user-manager/client-api/v2/users/') > -1 &&
          !request.url.endsWith('/me') &&
          !request.url.endsWith('/context') &&
          request.method === 'GET'
        ) {
          if (event instanceof HttpResponse) {
            const userDetails = event.body;

            return of(
              event.clone({
                body: {
                  ...userDetails,
                  firstName: userDetails.givenName,
                  email: userDetails.emailAddress,
                  legalEntityId: userDetails.legalEntityInternalId,
                  enabled: userDetails.status === 'ENABLED',
                  additions: userDetails.attributes,
                },
              }),
            );
          }
        }
        if (
          request.url.indexOf('api/access-control/client-api/v2/accessgroups/service-agreements/') > -1 &&
          request.url.endsWith('/users') &&
          request.method === 'GET'
        ) {
          if (event instanceof HttpResponse) {
            return this.getUserList(request).pipe(
              map(
                (body) =>
                  event.clone({
                    body: {
                      ...body,
                    },
                  }) as HttpEvent<any>,
              ),
            );
          }
        }
        return of(event);
      }),
    );
  }

  requestHandler(request: HttpRequest<any>): HttpRequest<any> {
    if (
      request.url.indexOf('/client-api/v2/accessgroups/service-agreements') > -1 &&
      request.url.indexOf('/users') > -1 &&
      request.url.indexOf('/permissions') > -1 &&
      request.method === 'PUT'
    ) {
      const index = request.url.indexOf('/accessgroups/service-agreements');
      const endpoint = request.url.slice(index, request.url.length);
      return request.clone({
        method: 'PUT',
        url: `/api/bss-user-service/client-api/v1${endpoint}`,
        body: { ...request.body },
      });
    }

    if (
      request.url.indexOf('api/access-control/client-api/v2/accessgroups/service-agreements/') > -1 &&
      request.url.endsWith('/users') &&
      request.method === 'GET'
    ) {
      return this.checkUserPermissions(request);
    }

    if (
      request.url.indexOf('/api/user-manager/client-api/v2/users/') > -1 &&
      !request.url.endsWith('/me') &&
      !request.url.endsWith('/context') &&
      request.method === 'GET'
    ) {
      const urlSplit = request.url.split('/');
      const userId = urlSplit[urlSplit.length - 1];
      const moreDataAfterId = !!urlSplit[urlSplit.length];

      if (!moreDataAfterId) {
        return request.clone({
          method: 'GET',
          url: `/api/bss-user-service/client-api/v1/users/identities/${userId}`,
        });
      }
    }

    if (request.url.indexOf('/api/access-control/client-api/v2/legalentities/') > -1 && request.method === 'GET') {
      const urlSplit = request.url.split('/');
      const legalEntityId = urlSplit[urlSplit.length - 1];
      const moreDataAfterId = !!urlSplit[urlSplit.length];
      if (!moreDataAfterId) {
        return request.clone({
          method: 'GET',
          url: `/api/bss-user-service/client-api/v1/legalentities/${legalEntityId}`,
        });
      }
    }

    return request;
  }

  getUserList(request: HttpRequest<any>) {
    let params = request.params;
    params = params.delete('query');
    params = params.append('search', request.params.get('query') || '');

    const urlSplit = request.url.split('/');
    const serviceAgreementId = urlSplit[urlSplit.length - 2];
    return this.httpClient.get(
      `/api/bss-user-service/client-api/v1/accessgroups/service-agreements/${serviceAgreementId}/users`,
      {
        params,
      },
    );
  }

  checkUserPermissions(request: HttpRequest<any>) {
    const params = new HttpParams({
      fromObject: { functionName: 'Manage Users', resourceName: 'User', privileges: 'view' },
    });

    return request.clone({
      method: 'GET',
      url: `/api/access-control/client-api/v2/accessgroups/users/user-permissions`,
      params,
    });
  }
}
